<!-- @format -->

<ng-container *transloco="let t">
  <div aria-live="polite" aria-atomic="true">
    <form>
      <fudis-heading [level]="2">{{ t("SELECT_COMPLETION_METHOD_MODAL.TITLE") }}</fudis-heading>
      <p class="sis-mb-md">{{ t("SELECT_COMPLETION_METHOD_MODAL.MODAL_HELP_TEXT") }}</p>
      <div class="modal-header">
        <sis-modal-close-button sisAutofocus />
      </div>
      <div class="modal-body">
        @if (assessmentItems$ | async) {
          <div class="sis-mb-md">
            <fudis-heading [level]="3">{{ t("SELECT_COMPLETION_METHOD_MODAL.CU_INFO_TITLE") }}</fudis-heading>
            @let versionOptions = options$ | async;
            <fudis-dl [variant]="'compact'">
              <fudis-dl-item>
                <fudis-dt [contentText]="t('SELECT_COMPLETION_METHOD_MODAL.CU_INFO_CU')"></fudis-dt>
                <fudis-dd>
                  <a
                    fudisLink
                    [title]="_values.courseUnit.name | localizedString"
                    [external]="true"
                    [href]="'/student/courseunit/' + _values.courseUnit.id"></a>
                </fudis-dd>
              </fudis-dl-item>
              @if (
                (!_values.isGradeRaiseAttempt && !_values.gradeRaiseAttempt) ||
                (_values.isGradeRaiseAttempt && _values.gradeRaiseAttempt) ||
                (_values.isGradeRaiseAttempt && !_values.gradeRaiseAttempt && (!versionOptions || versionOptions.length <= 1))
              ) {
                <fudis-dl-item>
                  <fudis-dt [contentText]="t('SELECT_COMPLETION_METHOD_MODAL.CU_INFO_VERSION')"></fudis-dt>
                  <fudis-dd>
                    {{ _values.courseUnit.curriculumPeriodIds | curriculumPeriodName | async }}
                    <sis-popover
                      [popoverText]="t('SELECT_COMPLETION_METHOD_MODAL.CU_INFO_VERSION_GUIDE')"
                      popoverClass="dark"
                      popoverPlacement="bottom"
                      (shown)="isOpen()"
                      (hidden)="isHidden()">
                      <button
                        type="button"
                        class="non-button sis-popover-trigger-content"
                        [attr.aria-label]="t('SELECT_COMPLETION_METHOD_MODAL.CU_INFO_VERSION_GUIDE_BUTTON')"
                        [attr.aria-expanded]="popoverShown">
                        <sis-icon [icon]="'info-circle'" [color]="'primary'"></sis-icon>
                      </button>
                    </sis-popover>
                  </fudis-dd>
                </fudis-dl-item>
              }
            </fudis-dl>
            @if (_values.isGradeRaiseAttempt && !_values.gradeRaiseAttempt && versionOptions && versionOptions.length > 1) {
              <fudis-select
                [label]="t('STUDIES.COURSE_UNIT_INFO_MODAL.COURSE_VERSION')"
                [selectionClearButton]="false"
                [control]="versionControl">
                <ng-template fudisSelectOptions>
                  @for (option of versionOptions; track option.value) {
                    <fudis-select-option [data]="option" />
                  }
                </ng-template>
              </fudis-select>
            }
          </div>
          <fieldset>
            <legend
              id="select-completion-method"
              tabindex="-1"
              class="fudis-heading__lg sis-mb-md"
              aria-describedby="select-completion-method__errors"
              >{{ t("SELECT_COMPLETION_METHOD_MODAL.CU_CM_TITLE") }}</legend
            >
            @for (completionMethod of getCompletionMethods(); track completionMethod; let index = $index) {
              <div
                class="completion-method-box"
                [class]="selectCompletionMethod()?.value === completionMethod.localId ? 'selected' : 'not-selected'">
                <sis-radio-button
                  [id]="completionMethod.localId"
                  [ariaDescribedBy]="completionMethod.localId + '_errors'"
                  [control]="selectCompletionMethod()"
                  [value]="completionMethod.localId"
                  [translatedLabel]="getCompletionMethodLabel(completionMethod, index)"
                  class="d-block fudis-heading__md">
                </sis-radio-button>
                <ng-container *ngTemplateOutlet="completionMethodContent; context: { completionMethod: completionMethod, index: index }">
                </ng-container>
              </div>
            }
            @if (_values.isGradeRaiseAttempt && _values.gradeRaiseAttempt) {
              <div
                [class]="selectCompletionMethod()?.value === gradeRaiseAttemptControlValue ? 'selected' : 'not-selected'"
                class="completion-method-box">
                <sis-radio-button
                  [id]="gradeRaiseAttemptControlValue"
                  [ariaDescribedBy]="gradeRaiseAttemptControlValue + '_errors'"
                  [control]="selectCompletionMethod()"
                  [value]="gradeRaiseAttemptControlValue"
                  [translatedLabel]="t('SELECT_COMPLETION_METHOD_MODAL.CANCEL_GRADE_RAISE_ATTEMPT')"
                  class="d-block fudis-heading__md">
                </sis-radio-button>
              </div>
            }
            <sis-validation-errors formFieldId="select-completion-method" [control]="selectCompletionMethod()"></sis-validation-errors>
          </fieldset>
          <ng-template #completionMethodContent let-completionMethod="completionMethod" let-index="index">
            <div class="sis-mb-sm">
              <div class="sis-pl-xl">
                <fudis-dl [variant]="'compact'">
                  @if (completionMethod.typeOfRequire === "OPTIONAL_WITH_REQUIRE_RANGE") {
                    <fudis-dl-item id="range-help-{{ index }}">
                      <fudis-dt [contentText]="t('COMPLETION_METHODS_LIST.DETAIL_VIEW.REQUIRED_RANGE')"></fudis-dt>
                      <fudis-dd [contentText]="completionMethod.require | intRange"></fudis-dd>
                    </fudis-dl-item>
                  }
                  @if (completionMethod.typeOfRequire !== "ALL_SELECTED_REQUIRED") {
                    <fudis-dl-item id="description-help-{{ index }}">
                      <fudis-dt [contentText]="t('COMPLETION_METHODS_LIST.DETAIL_VIEW.INSTRUCTIONS')"></fudis-dt>
                      @if (completionMethod.assessmentItemOptionalityDescription; as description) {
                        <fudis-dd
                          [contentText]="
                            description ? (description | localizedMarkupString) : t('COMPLETION_METHODS_LIST.DETAIL_VIEW.NO_INSTRUCTIONS')
                          "></fudis-dd>
                      }
                    </fudis-dl-item>
                  }
                </fudis-dl>
                @if (completionMethod.typeOfRequire === "ALL_SELECTED_REQUIRED") {
                  <ul>
                    @for (assessmentItemId of completionMethod.assessmentItemIds; track assessmentItemId) {
                      <li>
                        @if (assessmentItemId | assessmentItem | async; as assessmentItem) {
                          <div>
                            <span class="assessment-item-label">{{ getAssessmentItemLabel(assessmentItem) }}</span>
                            @if (_values.validatablePlan.isAssessmentItemAttained(assessmentItemId)) {
                              <fudis-badge variant="success">{{
                                t("SELECT_COMPLETION_METHOD_MODAL.ASSESSMENT_ITEM_ATTAINED")
                              }}</fudis-badge>
                            }
                          </div>
                        }
                      </li>
                    }
                  </ul>
                } @else {
                  @for (assessmentItemId of completionMethod.assessmentItemIds; track assessmentItemId) {
                    @if (assessmentItemId | assessmentItem | async; as assessmentItem) {
                      <div class="assessment-item-checkbox sis-mt-xs">
                        <sis-checkbox
                          class="assessment-item-label"
                          [ngClass]="{
                            invalid:
                              selectedAssessmentItems().invalid &&
                              selectedAssessmentItems().touched &&
                              !isAssessmentItemSelectedInCompletionMethod(assessmentItemId, completionMethod) &&
                              selectCompletionMethod()?.value === completionMethod.localId,
                          }"
                          [label]="getAssessmentItemLabel(assessmentItem)"
                          [checked]="isAssessmentItemSelectedInCompletionMethod(assessmentItemId, completionMethod)"
                          (checkedChange)="assessmentItemCheckboxClicked($event, completionMethod, assessmentItemId)"
                          [ariaDescribedBy]="getAriaDescribedByIndex(index)">
                        </sis-checkbox>
                        @if (_values.validatablePlan.isAssessmentItemAttained(assessmentItemId)) {
                          <fudis-badge class="sis-ml-xs" variant="success">{{
                            t("SELECT_COMPLETION_METHOD_MODAL.ASSESSMENT_ITEM_ATTAINED")
                          }}</fudis-badge>
                        }
                      </div>
                    }
                  }
                  @if (selectCompletionMethod()?.value === completionMethod.localId) {
                    <sis-validation-errors
                      [formFieldId]="completionMethod.localId"
                      [control]="selectedAssessmentItems()"></sis-validation-errors>
                  }
                }
              </div>
            </div>
          </ng-template>
          <div class="sis-mt-md">
            <fudis-heading [level]="3">{{ t("SELECT_COMPLETION_METHOD_MODAL.INFO_TITLE") }}</fudis-heading>
            <p>{{ t("SELECT_COMPLETION_METHOD_MODAL.INFO_TEXT") }}</p>
          </div>
        }
      </div>
      <div class="modal-footer confirm-dialog-footer">
        <fudis-button (handleClick)="cancel()" [label]="t('BUTTON.CANCEL')" variant="secondary"></fudis-button>
        <fudis-button (handleClick)="submit()" [label]="t('BUTTON.CONFIRM')"></fudis-button>
      </div>
    </form>
  </div>
</ng-container>
